// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-text-highlight_root__DUUP6","headline":"business-resource-text-highlight_headline__U2U9r","text":"business-resource-text-highlight_text__nVAYZ"};